import { LOGO } from '../constants/imageTemplates';
import config from '../config';
import { createAuth } from '@justgiving/auth';
import { getLoginPageUrlParameters } from './getLoginPageUrlParameters';

const { authCookieName, activeGroupCookieName, refreshAccessTokenUrl } = config;

export const auth = createAuth({
  documentOrReq: document,
  authCookieName,
  activeGroupCookieName,
  refreshAccessTokenUrl,
});

export const getCharityId = () => {
  const permission = auth.getActivePermission('charity');

  return permission?.groupTypeExternalId
    ? parseInt(permission.groupTypeExternalId, 10)
    : undefined;
};

export const isCampaignAdmin = () => {
  return (
    auth.hasGroupRole('charity', 'admin') ||
    auth.hasGroupRole('charity', 'fundraising')
  );
};

export const getUserFullName = () => {
  const token = auth.getAccessToken();
  return token?.givenName || token?.familyName
    ? `${token.givenName} ${token?.familyName}`
    : null;
};

type GetLoginUrlParams = {
  campaignId?: string;
  campaignTitle?: string;
  causeLogo?: string;
  charityName?: string;
  eventName?: string;
  title?: string;
  logo?: string;
};

export function getLoginUrl(params?: GetLoginUrlParams) {
  const ssoUrl = new URL(config.consumerSSOUrl);
  ssoUrl.searchParams.set('returnUrl', window.location.href);
  ssoUrl.searchParams.set('SocialButtonStyle', 'light');
  ssoUrl.searchParams.set('Promo', 'true');

  if (params) {
    ssoUrl.searchParams.set(
      'EncodedOptions',
      getLoginPageUrlParameters({
        campaignId: params.campaignId,
        campaignTitle: params.campaignTitle,
        causeLogo: `${params.causeLogo}?template=${LOGO}`,
        charityName: params.charityName,
        eventName: params.eventName,
        title: params.title,
      }) ?? ''
    );
  }

  return ssoUrl.toString();
}
